import moment from 'moment';
import { ConfigProvider } from 'antd';
import { ConfigProvider as ConfigProvider5 } from 'antd-v5';
import { Provider } from 'react-redux';
import { I18n } from '@aws-amplify/core';
import { Router } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import 'antd/dist/antd.less';
import './styles/antd.less';
import 'moment/dist/locale/pt';
import 'moment/dist/locale/es';
import 'moment/dist/locale/de';
import 'moment/dist/locale/zh-cn';
import antdPtBr from 'antd/es/locale/pt_BR';
import antdEsEs from 'antd/es/locale/es_ES';
import antdDeDe from 'antd/es/locale/de_DE';
import antdZhCn from 'antd/es/locale/zh_CN';

import store from './store';
import Routes from './routes';
import dictionary from './i18n';
import history from './store/history';
import { queryClient } from '@/store/query';
import { GlobalStyles } from './styles/global';
import { lightTheme } from './styles/themes/light';
import { LocalesOptions, LocaleSelected } from './types';
import { ApplicationProvider } from './context/Application';
// import { Maintenance } from '@/pages/Maintenance';

const language: string = navigator.language;

moment.locale(language);
I18n.setLanguage(language);
I18n.putVocabularies(dictionary);

const antdLocales: LocalesOptions = {
	en: undefined,
	pt: antdPtBr,
	es: antdEsEs,
	de: antdDeDe,
	zh: antdZhCn
};

const antdLocale: LocaleSelected = antdLocales[language.substring(0, 2)] ?? antdLocales.en;

const isDevelopment = import.meta.env.VITE_NODE_ENV === 'development';

export const App = () => (
	<ThemeProvider theme={lightTheme}>
		<GlobalStyles />
		{/* <Maintenance /> */}
		<ConfigProvider locale={antdLocale}>
			<ConfigProvider5 prefixCls="kinebot">
				<QueryClientProvider client={queryClient}>
					<Provider store={store}>
						<Router history={history}>
							<ApplicationProvider>
								<Routes />
							</ApplicationProvider>
						</Router>
					</Provider>
					{isDevelopment ? <ReactQueryDevtools initialIsOpen={false} /> : null}
				</QueryClientProvider>
			</ConfigProvider5>
		</ConfigProvider>
	</ThemeProvider>
);
